export default {
  acceptSimulatedDuration: 'Akceptuj symulowany czas trwania',
  simulatedDuration: 'Symulowany czas trwania',
  actualValue: 'Wartość rzeczywista',
};
